<p-dialog
        [(visible)]="visible"
        [modal]="true"
        [closable]="false"
        [header]="header"
        [style]="{ width: '400px' }"
>
    <p>{{ message }}</p>

    <div class="mt-3">
        <p-iftalabel>
            <textarea
                    id="comment"
                    pTextarea
                    [(ngModel)]="comment"
                    rows="2"
                    cols="30"
                    style="resize: none"
                    class="w-full"
                    [disabled]="loading"
            ></textarea>
            <label for="comment">Comment</label>
        </p-iftalabel>
    </div>
    <div class="mt-3 flex justify-end gap-2">
        <p-button
                label="Cancel"
                severity="secondary"
                (click)="cancel()"
                [disabled]="loading"
        ></p-button>
        <p-button
                label="Confirm"
                (click)="toggle()"
                [loading]="loading"
        ></p-button>
    </div>
</p-dialog>
